/*************************************************/
/* TABS COMPONENT                                */
/*************************************************/

export function tabs() {
    const roots = document.querySelectorAll('.tabs-component');
    if (!roots.length) return;
    
    roots.forEach(initTabsInstance);
}

/**
 * Initializes a single tabs instance.
 * @param {HTMLElement} root 
 */

function initTabsInstance(root) {
    if (!root || root.dataset.initialized === 'true') return;

    // Cache static elements to avoid repeated DOM lookups
    const buttons = Array.from(root.querySelectorAll('.tabs-component__header-nav-item button'));
    const items = Array.from(root.querySelectorAll('.tabs-component__container .accordion__item'));
    const select = root.querySelector('.tabs-component__select');

    if (buttons.length === 0) return;

    // Register button clicks
    buttons.forEach((btn, idx) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            updateTabsState(buttons, items, select, root, idx);
        });
    });

    // Register dropdown changes
    if (select) {
        select.addEventListener('change', (e) => {
            const selectedIndex = e.target.selectedIndex;
            updateTabsState(buttons, items, select, root, selectedIndex);
        });
    }

    root.dataset.initialized = 'true';
}

/*
 Updates the UI state for buttons, content panels, and dropdowns.
 */

function updateTabsState(buttons, items, select, root, activeIndex) {
    // 1. Update Buttons state
    buttons.forEach((btn, idx) => {
        btn.classList.toggle('active-title', idx === activeIndex);
    });

    // 2. Update Content Panels state
    // Attempt to find by data attribute first for specific targeting, fallback to index
    const targetId = buttons[activeIndex]?.dataset.tabTarget;
    let targetPanel = targetId ? root.querySelector(`.accordion__item[data-tab-id="${targetId}"]`) : null;
    
    if (!targetPanel) {
        targetPanel = root.querySelector(`.accordion__item[data-accordion-item-index="${activeIndex}"]`) || items[activeIndex];
    }

    items.forEach((item) => {
        item.classList.toggle('accordion__item--active', item === targetPanel);
    });

    // 3. Update Dropdown state
    if (select && select.selectedIndex !== activeIndex) {
        select.selectedIndex = activeIndex;
    }
}